import gql from 'graphql-tag'

export const getRecordTypes = gql`
  query($masterType: RecordTypeMaster, $orderBy: RecordTypesOrder, $paging: PagingQuery) {
    getRecordTypes(
      filter: {
        master: $masterType
      },
      order: $orderBy,
      paging: $paging,
    ) {
      recordTypes {
        id
        name
        description
        master
        usedTimes
        additionalInfo {
          title
          items {
            keyName
            type
            name
            options
            required
            emphatic
            store
            defaultVal
            addon
            displayKey
          }
        }
      }
    }
  }
`

export const getRecordType = gql`
  query($recordTypeId: Int!) {
    getRecordType(
      recordTypeId: $recordTypeId
    ) {
      id
      name
      description
      master
      additionalInfo {
        title
        items {
          keyName
          type
          name
          options
          required
          emphatic
          store
          defaultVal
          addon
          displayKey
        }
      }
    }
  }
`

export const getCandidateRecordTypes = gql`
  query($masterType: RecordTypeMaster, $orderBy: RecordTypesOrder, $paging: PagingQuery) {
    getRecordTypes(
      filter: {
        master: $masterType
      },
      order: $orderBy,
      paging: $paging,
    ) {
      recordTypes {
        id
        name
        description
        master
        usedTimes
      }
    }
  }
`
